import { memo } from 'react'
import { useFlag } from '@unleash/proxy-client-react'
import { Button, List, ListItem, ListItemIcon, Stack, styled } from '@mui/material'
import { HelpOutline, LogoutOutlined, PersonOutline } from '@mui/icons-material'
import { getAuth, signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import Cookies from 'universal-cookie/es6'
import logger from '../../../../../utils/logger'
import config, { superUglyHackToClearAllCookies } from '../../../../../config'
import { authenticatedUserVar, drawerVar } from '../../../../../providers/apollo/cache'

const AccountList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 0',
  gap: '16px',
  borderTop: '1px solid #E1E1E1',
  '.MuiListItem-root': {
    padding: 0
  },
  '.MuiButton-root': {
    gap: '8px',
    padding: 0,
    color: '#727C8C',
    fontSize: '0.875rem',
    fontWeight: 500,
    '.MuiListItemIcon-root': {
      minWidth: 0,
      color: '#727C8C',
      '.MuiSvgIcon-root': {
        maxWidth: '20px'
      }
    },
    '&:hover': {
      background: 'transparent',
      color: theme.palette.primary.main,
      '.MuiListItemIcon-root': {
        color: theme.palette.primary.main
      }
    }
  }
}))

function AccountMenu() {
  const navigate = useNavigate()
  const enabledNewBucketSwitcher = useFlag('enabledNewBucketSwitcher')

  const handleLogout = async () => {
    try {
      const auth = getAuth()
      await signOut(auth)
    } catch (error) {
      logger.error(error)
    }

    const cookies = new Cookies()
    cookies.remove('app_auth', config.cookieOptions)
    superUglyHackToClearAllCookies.forEach((cookieConfig) => cookies.remove('app_auth', cookieConfig))
    cookies.remove('facebook_dtp', config.cookieOptions)
    superUglyHackToClearAllCookies.forEach((cookieConfig) => cookies.remove('facebook_dtp', cookieConfig))
    localStorage.removeItem('reduxPersist:auth')
    localStorage.removeItem('_pb_userData:username')
    authenticatedUserVar(null)
    window.location.href = '/?logout=true'
  }

  const handleAccountNavigation = () => {
    navigate('/settings#profile')
    drawerVar(null)
  }

  return (
    <Stack sx={{ padding: '0 16px' }}>
      <AccountList>
        {enabledNewBucketSwitcher && (
          <>
            <ListItem>
              <Button onClick={handleAccountNavigation}>
                <ListItemIcon>
                  <PersonOutline />
                </ListItemIcon>
                My Account
              </Button>
            </ListItem>
            <ListItem>
              <Button onClick={handleLogout} variant="text">
                <ListItemIcon>
                  <LogoutOutlined />
                </ListItemIcon>
                Logout
              </Button>
            </ListItem>
          </>
        )}
        <ListItem>
          <Button variant="text" data-test="pendo-rc-button">
            <ListItemIcon>
              <HelpOutline />
            </ListItemIcon>
            Support
          </Button>
        </ListItem>
      </AccountList>
    </Stack>
  )
}

export default memo(AccountMenu)
